import styled from 'styled-components/macro';

export const Wrapper = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  width: 90%;
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'auto')};
`;

export const SelectedItemWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding: 4px 6px 4px 8px;
  background-color: #f2f5f8;
  border-radius: 4px;
`;
